/**
 * Cache keys for the manufacturer data agent (USA-1474). The threads sit under "communications" and the
 * Action Items list under "projects", so the shared thread and action-list mutations refresh them too.
 */
export const manufacturerDataKeys = {
  all: ['manufacturer-data'] as const,
  agent: (manufacturerUuid: string) => ['manufacturer-data', 'agent', manufacturerUuid] as const,
  threads: (manufacturerUuid: string) => ['communications', 'manufacturer-data', manufacturerUuid] as const,
  actionsAll: ['projects', 'manufacturer-data-actions'] as const,
  actions: (params?: unknown) => ['projects', 'manufacturer-data-actions', params] as const,
}
